import { createActions } from 'redux-actions';
import * as API from '../../api/reviews';
import { SET_REVIEWS, RESET_REVIEWS } from '../constants';
import * as miscellaneousAPI from '@api/miscellaneous';
import { commonService } from '@services/commonService';

export const resetReviews = () => ({ type: RESET_REVIEWS });

export const { setReviews } = createActions(SET_REVIEWS);

export const fetchReviews = id => async dispatch => {
  try {
    const res = await API.fetchReviews(id);
    dispatch(setReviews({ reviews: res.data.results }));
    return res;
  } catch (e) {
    throw e;
  }
};

export const addReview = (point) =>
  async (dispatch, getState) => {
    const {
      reviews: {
        content,
        authorName,
        authorEmail,
        compliance
      }
    } = getState();

    if (!content || !authorName || !authorEmail || !compliance) {
      dispatch(setReviews({ error: true }));
      throw Error;
    }

    try {
      const res = await miscellaneousAPI.sendFeedback({
        author_email: authorEmail,
        author_name: authorName,
        content,
        point: point.id,
        platform: commonService.getFormFactor()
      });
      dispatch(setReviews({ isSent: true}));

      return res;
    } catch (e) {
      dispatch(setReviews({ error: true }));
      throw e;
    }
  };
